module.exports = "/packs/absent-bd7c180ba9250d2f3be9ca45090940d5.svg";